import { useState } from "react";
import { ChevronLeft, ChevronRight, X, ExternalLink } from "lucide-react";
import { asset } from "@/lib/api";

export function GalleryOverlay({ items, onClose, onBook }) {
  const [i, setI] = useState(0);
  const g = items[i];
  if (!g) return null;
  const go = (d) => setI((i + d + items.length) % items.length);
  return (
    <div className="absolute inset-0 z-40 bg-slate-950/95 flex flex-col items-center justify-center p-4 sm:p-10" data-testid="gallery-overlay">
      <button onClick={onClose} className="absolute top-4 right-4 w-11 h-11 rounded-full glass-dark grid place-items-center" data-testid="gallery-close"><X className="w-5 h-5" /></button>
      <div className="relative w-full max-w-5xl flex items-center justify-center">
        {items.length > 1 && <button onClick={() => go(-1)} className="absolute left-0 w-11 h-11 rounded-full glass-dark grid place-items-center z-10" data-testid="gallery-prev"><ChevronLeft className="w-5 h-5" /></button>}
        <img src={asset(g.url)} alt={g.caption || ""} className="max-h-[68vh] max-w-full rounded-2xl object-contain" data-testid="gallery-image" />
        {items.length > 1 && <button onClick={() => go(1)} className="absolute right-0 w-11 h-11 rounded-full glass-dark grid place-items-center z-10" data-testid="gallery-next"><ChevronRight className="w-5 h-5" /></button>}
      </div>
      <div className="mt-5 text-center max-w-2xl">
        {g.caption && <p className="font-serif text-xl" data-testid="gallery-caption">{g.caption}</p>}
        <p className="text-xs text-white/50 mt-1">{i + 1} / {items.length}</p>
        {g.link_label && g.link_url && (g.link_url === "#book"
          ? onBook && <button onClick={onBook} className="mt-4 h-11 px-6 rounded-full bg-ba text-white text-sm font-semibold" data-testid="gallery-link-button">{g.link_label}</button>
          : <a href={g.link_url} target="_blank" rel="noopener noreferrer" className="mt-4 h-11 px-6 rounded-full bg-ba text-white text-sm font-semibold inline-flex items-center gap-2" data-testid="gallery-link-button">{g.link_label}<ExternalLink className="w-4 h-4" /></a>)}
      </div>
      {items.length > 1 && (
        <div className="mt-5 flex gap-2 overflow-x-auto no-scrollbar max-w-full">
          {items.map((x, k) => <button key={x.id} onClick={() => setI(k)} className={`shrink-0 w-16 h-12 rounded-lg overflow-hidden border-2 ${k === i ? "border-white" : "border-transparent opacity-60"}`} data-testid={`gallery-thumb-${k}`}><img src={asset(x.url)} alt="" className="w-full h-full object-cover" /></button>)}
        </div>
      )}
    </div>
  );
}
